import { Controller } from "@hotwired/stimulus"
import "jquery.tagsinput"
import { show_error, show_success, remove_flash, check_auth_status } from "lib/helpers"

// content/edit — data-controller="content--edit"
export default class extends Controller {
  connect() {
    this.#initTagsInput()
    document.addEventListener("click", this.boundPopularTagClick)

    $(this.element).ajaxForm({
      dataType: "json",
      beforeSubmit: () => {
        remove_flash()
        this.#waitMessage()
      },
      success: (response) => {
        this.#waitMessage()
        if (!response.success) {
          const messages = response.messages || [response.message || "An error occurred during request"]
          messages.forEach((message) => show_error(message))
        } else {
          show_success(response.message)
        }

        this.#endWaitMessage()
        this.#scrollToMessages()
      },
      error: (response) => {
        this.#endWaitMessage()
        check_auth_status(response.status)
        this.#scrollToMessages()
        show_error("An error occurred during request")
      },
    })
  }

  disconnect() {
    document.removeEventListener("click", this.boundPopularTagClick)
    $(this.element).ajaxFormUnbind()
    this.#destroyTagsInput()
  }

  boundPopularTagClick = (event) => {
    const item = event.target.closest(".popular-tags li")
    if (!item) return

    event.preventDefault()

    const tag = $(item).find(".tag").html()
    const receiver = $("#tags")

    if (!receiver.tagExist(tag)) {
      receiver.addTag(tag, {
        focus: true,
        interactive: true,
        hint_selector: "#tags_hint",
      })
    }
  }

  #initTagsInput() {
    const $tags = $("#tags")
    if (!$tags.length || document.getElementById(`${$tags.attr("id")}_tagsinput`)) return

    $tags.tagsInput({
      interactive: true,
      width: "100%",
      height: "34px",
      defaultText: "",
      focus: "true",
    })
  }

  #destroyTagsInput() {
    const $tags = $("#tags")
    if (!$tags.length) return

    const wrapper = document.getElementById(`${$tags.attr("id")}_tagsinput`)
    if (wrapper) wrapper.remove()
    $tags.show()
  }

  #waitMessage() {
    $(this.element).find("#blob_submit").enable(false)
    $(this.element).find(".inline-loading").fadeIn()
  }

  #endWaitMessage() {
    $(this.element).find("#blob_submit").enable(true)
    $(this.element).find(".inline-loading").fadeOut()
  }

  #scrollToMessages() {
    $.scrollTo("#container", "slow")
    $.scrollTo(".form-results-success")
    $("body, html").animate({ scrollTop: 0 }, 800)
  }
}
